export const formatValue = function (value, locale) {
    const separator = locale === 'nl' ? '.' : ',';
    const withThousandSeparators = value
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    return `&euro;&nbsp;${withThousandSeparators}`;
};
